<template>
  <div>
    <HeroBar :has-right-visible="false">
      Legal
    </HeroBar>
    <section class="section is-main-section">
      <CardComponent> </CardComponent>
    </section>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
export default {
  name: 'Legal',
  components: {
    CardComponent,
    HeroBar
  },
  metaInfo: {
    title: 'Legal',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: ''
      }
    ]
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {},
  methods: {}
}
</script>
